import React from "react";
import { displayErrors } from "Client/utils";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import PanelSegment from "components/panels/PanelSegment/PanelSegment";
import Table from "components/Tables/Table";
import { useMutation } from "@tanstack/react-query";
import SubLabel from "components/Atoms/Sublabel";
import VatRatesAddModal from "./VatRatesAddModal";
import { CustomSection } from "components/MainSectionTemplate/types";
interface Props {
  activeVatRates: server.dto.VatRate[]
  client: server.dto.Client
}

const VatRatesPanel = (props: Props) => {
  const [activeVatRates, setActiveVatRates] = React.useState(props.activeVatRates);
  const [isAddingVatRate, setIsAddingVateRate] = React.useState<boolean>(false);

  const removeVatRateMutation = useMutation(window.CoreApi.Client.RemoveVatRateFromClient);
  const addVatRateMutation = useMutation(window.CoreApi.Client.AddVatRateToClient);

  const onVatRateAdd = async (vatRate: server.dto.VatRate) => {
    const res = await addVatRateMutation.mutateAsync({ clientId: props.client.clientId, vatRateId: vatRate.vatRateId });
    if (res.data.hasErrors) {
      displayErrors(res);
    } else {
      setActiveVatRates((prev) => ([...prev, vatRate]));
      setIsAddingVateRate(false);
    }
  };

  const onVatRateDelete = async (vat: server.dto.VatRate) => {
    window.displayDeleteConfirmationModal({
      onDeleteHandler: async () => {
        const res = await removeVatRateMutation.mutateAsync({ clientId: props.client.clientId, vatRateId: vat.vatRateId });
        if (res.data.hasErrors) {
          displayErrors(res);
        } else {
          setActiveVatRates((prev) => prev.filter(f => f.vatRateId !== vat.vatRateId));
        }
      }
    })
  };

  return <SectionPanel.Panel
    header={<>
      <PanelSegment.Title title={"VAT rates"} />
      <PanelSegment.Button onClick={() => setIsAddingVateRate(true)} label={RESX.Buttons.btnNew} type="secondary" />
    </>}
  >
    <Table
      items={activeVatRates}
      isLoading={false}
      getKey={vatRate => vatRate.vatRateId.toString()}
      onDelete={onVatRateDelete}
      hideHeader
      columns={[
        {
          key: "title",
          header: "",
          render: vat => <div>
            <div>{vat.internalName} ({vat.percentageFormatted})</div>
            <SubLabel>VatRateId:{vat.vatRateId}</SubLabel>
          </div>
        }
      ]}
    />

    {isAddingVatRate && <VatRatesAddModal addVatRate={onVatRateAdd} onClose={() => setIsAddingVateRate(false)} activeVatRates={activeVatRates} />}
  </SectionPanel.Panel>
};

export const vatRatesPanelSection = (activeVatRates: server.dto.VatRate[], client: server.dto.Client): CustomSection => {
  return {
    key: "vatRates",
    type: "custom",
    render: () => <VatRatesPanel key="vatRates" activeVatRates={activeVatRates} client={client} />
  }
}